import { FieldType } from '../../types/Field.type';
export const PersonRoleRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.person_role.label',
    fallbackLabel: 'Role',
    type: FieldType.Enum,
    options: [
        { key: 'LEGAL_REPRESENTATIVE', label: 'fields.enm.person_role.options.LEGAL_REPRESENTATIVE', fallbackLabel: 'Legal Representative' },
        { key: 'ALTERNATIVE_BENEFICIAL_OWNER', label: 'fields.enm.person_role.options.ALTERNATIVE_BENEFICIAL_OWNER', fallbackLabel: 'Alternative Beneficial Owner' },
        { key: 'ULTIMATE_BENEFICIAL_OWNER', label: 'fields.enm.person_role.options.ULTIMATE_BENEFICIAL_OWNER', fallbackLabel: 'Ultimate Beneficial Owner' },
        { key: 'OWNER', label: 'fields.enm.person_role.options.OWNER', fallbackLabel: 'Owner' },
    ],
    trackFieldValueWithAnalytics: false,
};
